/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 11:50:22                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 17:14:44                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * CompInfoSelectMulti: display compinfo checkbox type
*/

/* Imports */
import { t } from "../../../../i18n";
import type { Theme } from "react-select";
import MultiCheckSelect from "../../../option-select/MultiCheckSelect";
/***/

/**
* CompInfoSelectMulti: display compinfo multi select type
* @param choices - list of avaible choices
* @param values - previous selected values
* @param onChange - on change event
* @param className - Additional classname
*/
export default function CompInfoSelectMulti({
  choices,
  values,
  onChange,
  className = ""
}: {
  choices: EasyTech.CompInfoChoice[],
  values: EasyTech.CompInfoChoice[],
  onChange: (data: EasyTech.CompInfoChoice[]) => void,
  className?: string
}) {
  /**
   * Récupère le label traduit d'un choix de compInfo selon la langue de l'utilisateur
   * @param choice - Choix contenant les traductions
   * @returns Label traduit ou label par défaut
   */
  const getTranslatedChoiceLabel = (choice: EasyTech.CompInfoChoice): string => {
    const currentLanguage = localStorage.getItem("i18nextLng") || "en";
    
    if (choice.translations && Array.isArray(choice.translations)) {
      const translation = choice.translations.find(
        (translation) => translation.language?.isoCode === currentLanguage
      );
      
      if (translation && translation.label) {
        return translation.label;
      }
    }
    
    // Fallback sur le label par défaut
    return choice.label || "";
  };

  return (
    <>
      <MultiCheckSelect options={choices.map((choice) => ({label: getTranslatedChoiceLabel(choice), value: choice}))}
              value={values.map((val) => ({label: getTranslatedChoiceLabel(val), value: val}))}
              theme={(theme: Theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary: "#41A1FF",
                },
              })}
              onChange={(e: { value: EasyTech.CompInfoChoice }[] | null) => onChange((e ?? []).map((el) => el.value))}
              className={`min-w-0 w-full ${className}`}
              placeholder={t("common:select")} />
    </>
  );
}
/***/
